import React, { Fragment } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import styles from './styles/forms.module.scss'
import { ErrorIco } from 'media/icons'
import getPlaceholder from './getPlaceholder'

const withContainer = WrapedComponent => ({
	style,
	shrink,
	className,
	label,
	labelT,
	placeholder,
	usePlaceholder,
	error,
	warning,
	errorClass,
	noError,
	tooltip,
	fieldIco,
	fieldIcoPos,
	...rest
}) => {
	const { value } = rest.fieldState || rest
	const isFieldEmpty = value === 0 ? false : !value
	const isLabelComplex = typeof label === 'object'
	const { t, i18n } = useTranslation()
	const resolvedLabel = labelT ? t(labelT) : label
	const resolvePlaceholder = type => usePlaceholder ? getPlaceholder({ type, placeholder, labelT, t, i18n }) : ''
	return(
		<Fragment>
			{(!!resolvedLabel && !rest.hidden && !isLabelComplex) &&
				<p className={classNames(styles.label, { [styles['highlighted-label']]: !isFieldEmpty, 'field-disabled': rest.disabled })}>{resolvedLabel}</p>
			}
			<div
				style={style}
				// 'title' on disabled field is not displayed because of :before of div
				{...(rest.disabled && rest.title) && { title: rest.title }}
				className={classNames(
					styles['field-input-container'],
					{
						[styles['shrink-field-container']]: shrink,
						[className]: className,
						[styles.error]: error,
						[errorClass]: error && errorClass,
						'field-disabled': rest.disabled
					}
				)}
			>
				<WrapedComponent
					style={{ ...fieldIcoPos === 'left' && { paddingLeft: '20px' }, ...fieldIcoPos === 'right' && { paddingRight: '20px' } }}
					{...rest}
					{...isLabelComplex && { label }}
					resolvePlaceholder={resolvePlaceholder}
				/>
				{((!noError && error) || warning) &&
					<span className={classNames('error-container', styles['error-bottom'])}>
						<ErrorIco /> <span title={error || warning}>{error || warning}</span>
					</span>
				}
				{fieldIco &&
					<div
						className={classNames(styles['icon-wrapper'], {
							[styles.left]: fieldIcoPos === 'left',
							[styles.right]: fieldIcoPos === 'right'
						})}
					>
						{fieldIco}
					</div>
				}
				{tooltip && <div className={styles['field-tooltip']}>{tooltip}</div>}
			</div>
		</Fragment>
	)
}


export default withContainer
